import CryptoJS from "crypto-js";

export function encrypt(str: string): string {
    const key = CryptoJS.enc.Hex.parse("0123456789abcdef0123456789abcdef");
    const iv = CryptoJS.enc.Hex.parse("abcdef9876543210abcdef9876543210");

    const encrypted = CryptoJS.AES.encrypt(str, key, { iv: iv });
    return encrypted.toString();
}

export function decrypt(str: string): string | null {
    const key = CryptoJS.enc.Hex.parse("0123456789abcdef0123456789abcdef");
    const iv = CryptoJS.enc.Hex.parse("abcdef9876543210abcdef9876543210");
    const cipher = CryptoJS.AES.decrypt(str, key, {
        iv: iv,
    });
    return cipher.toString(CryptoJS.enc.Utf8);
}
